/**
 * @desc 登录
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 令牌 */
  token?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/web/sso/login',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/mock/web/sso/login',

    params,
  });
}
